const element = document.getElementById("Details-HeaderMenu-2");

element.addEventListener("mouseover", function () {
  element.setAttribute("open", "true");
});

element.addEventListener("mouseout", function () {
  element.removeAttribute("open");
});

// COLLAPSE DESCRIPTION
  document.addEventListener('DOMContentLoaded', function () {
    const btn = document.querySelector('.toggle-description-btn');
    const wrapper = document.querySelector('.d-description-wrapper');

    if (btn && wrapper) {
      const collapsedHeight = 150; // match CSS

      btn.addEventListener('click', function () {
        const isExpanded = wrapper.classList.contains('expanded');

        if (isExpanded) {
          wrapper.style.maxHeight = collapsedHeight + 'px';
          wrapper.classList.remove('expanded');
          btn.textContent = 'Read More';
        } else {
          // measure full height
          const fullHeight = wrapper.scrollHeight;
          wrapper.style.maxHeight = fullHeight + 'px';
          wrapper.classList.add('expanded');
          btn.textContent = 'Read Less';
        }
      });
    }
  });

